import { useEffect } from 'react';
import { noop } from 'lodash';
import { useModal, useUser } from '../contexts';
import CompleteProfileModal from '../components/modals/CompleteProfileModal';

export const useModalReminders = () => {
  const { user, isUserProfileComplete } = useUser();
  const { setModal } = useModal();

  useEffect(() => {
    if (user && !isUserProfileComplete) {
      setModal(<CompleteProfileModal user={user} />, {
        onClose: noop,
        disableEscapeKeyDown: true,
        hideCloseButton: true,
      });
    }
  }, [user, isUserProfileComplete, setModal]);

  return null;
};
